import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { push } from 'connected-react-router'
import { generateRoute } from '../i18n/helpers'

const Signup = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const userLoaded = useSelector((state) => state.user.userLoaded)
  const userAuthenticated = useSelector((state) => state.user.userAuthenticated)

  useEffect(() => {
    if (userLoaded) {
      dispatch(
        push(
          generateRoute(
            intl.locale,
            userAuthenticated ? 'routes.home' : 'routes.login'
          )
        )
      )
    }
  }, [dispatch, intl.locale, userLoaded, userAuthenticated])

  return null
}

export default Signup
